import type { FrameSpec } from '../config/frames';

/**
 * A42F — normalised product photos (tools/catalogue/normalise_photos.py):
 * each real front photo is trimmed to the frame and centred at the same width
 * on a white 800 × 480 canvas, so every frame looks the same size.
 */
const NORMALISED = import.meta.glob('../../assets-source/derived/catalogue/*.webp', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;
const BY_NAME = new Map(Object.entries(NORMALISED).map(([path, url]) => [path.slice(path.lastIndexOf('/') + 1, -'.webp'.length), url]));
/** Catalogue ids whose photo file carries another name. */
const ALIASES: Record<string, string> = { 'komodo-rise-olive': 'komodo-rise' };

export interface FramePhoto { src: string; normalised: boolean }

export function framePhoto(frame: FrameSpec): FramePhoto {
  const url = BY_NAME.get(ALIASES[frame.id] ?? frame.id);
  if (url) return { src: url, normalised: true };
  if (frame.id === 'komodo-rise-olive') return { src: new URL('../../assets-source/komodo-rise/front.png', import.meta.url).href, normalised: false };
  return { src: (frame as FrameSpec & { thumbnail?: string }).thumbnail ?? frame.silhouette?.frontPhoto?.dataUrl ?? '', normalised: false };
}
